<template>
    <div class="table">
        <div class="container">
            <el-container>
            <el-main>
                <el-col :span="6">
                    <el-tree
                      :data="resourceData"
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      ref="tree"
                      highlight-current
                      :expand-on-click-node="false"
                      @check-change="nodeChange"
                      @node-click="nodeClick"
                      :props="treeProps"
                      >
                    </el-tree>
                </el-col>
                <el-col :span="6">
                    <div class="handle-box" style="width:100%">
                        <el-select style="width:100%" v-model="select_module" @change="moduleChage" placeholder="模块筛选" class="handle-select mr10">
                            <el-option v-for="module of modules" :key="module.id" :label="module.name" :value="module.packagePath"></el-option>
                        </el-select>
                    </div>
                    <div class="handle-box" style="width:100%">
                        <el-input type="text" disabled v-model="current.resourceName"></el-input>
                    </div>
                    <div class="handle-box">
                        <el-button type="primary" :disabled="createBtnVisible" @click="handleCreate">新建</el-button>
                        <el-button type="primary" :disabled="editBtnVisible" @click="handleEdit">修改</el-button>
                        <el-button type="primary" :disabled="delBtnVisible" @click="handleDel">删除</el-button>
                        <el-button type="primary" :disabled="delsBtnVisible" @click="handleDels">批量删除</el-button>
                    </div>
                    <div :style="{'display':createVisible?'block':'none'}">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>新建资源</span>&nbsp;&nbsp;
                                <i :class="'el-icon-lx-'+form.resourceIcon"></i>
                                <el-button @click="saveCreate" type="primary" style="float: right; padding: 3px 6px;">确 定</el-button>
                            </div>
                            <div>
                                <el-form :model="form" label-width="100px" >
                                    <el-form-item label="资源名称">
                                        <el-input type="text" v-model="form.resourceName"></el-input>
                                    </el-form-item>
                                    <el-form-item label="资源路径">
                                        <el-input type="text" v-model="form.resourcePath"></el-input>
                                    </el-form-item>
                                     <el-form-item label="资源图标">
                                        <el-input type="text" v-model="form.resourceIcon"></el-input>
                                    </el-form-item>
                                    <el-form-item label="详细信息">
                                        <el-input type="textarea" v-model="form.detail"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-card>
                    </div>
                    <div :style="{'display':editVisible?'block':'none'}">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>修改资源</span>&nbsp;&nbsp;
                                <i :class="'el-icon-lx-'+form.resourceIcon"></i>
                                <el-button @click="saveEdit" type="primary" style="float: right; padding: 3px 6px;">确 定</el-button>
                            </div>
                            <div>
                                <el-form :model="form" label-width="100px">
                                    <el-form-item label="资源名称">
                                        <el-input type="text" v-model="form.resourceName"></el-input>
                                    </el-form-item>
                                    <el-form-item label="资源路径">
                                        <el-input type="text" v-model="form.resourcePath"></el-input>
                                    </el-form-item>
                                    <el-form-item label="资源图标">
                                        <el-input type="text" v-model="form.resourceIcon"></el-input>
                                    </el-form-item>
                                    <el-form-item label="详细信息">
                                        <el-input type="textarea" v-model="form.detail"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-card>
                    </div>
                </el-col>
                <el-col :span="12" style="padding-left:60px;height:480px;">
                    <el-scrollbar style="height:100%">
                        <v-icon></v-icon>
                    </el-scrollbar>
                </el-col>
            </el-main>
            </el-container>
        </div>
        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delVisible" width="300px" center>
            <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteNode">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delsVisible" width="300px" center>
            <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delsVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteNodes">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import vIcon from '../old/Icon.vue';

    export default {
        name: 'basetable',
        data() {
            return {
                select_module:'cn.deacy.shiro',
                modules:'',
                delsBtnVisible: true,
                delBtnVisible: true,
                editBtnVisible: true,
                createBtnVisible: false,
                createVisible: false,
                editVisible: false,
                delVisible: false,
                delsVisible: false,
                resourceData:[],
                checkedResourceData:[],
                treeProps:{
                     label:function(data,node){
                        return data.resource.resourceName;
                    },
                    children:"childList"
                },
                current:{
                    id:'0',
                    resourceName:'根元素'
                },
                form:{}

            }
        },
        components:{
            vIcon
        },
        created() {
            this.initModules();            
        },
        methods: {
            resetCurrent() {
                this.current = {
                    id:'0',
                    resourceName:'根元素'
                }
            },
            // 获取 tree
            getData() {
                this.$axios({
                    method:'get',
                    url: '/api/resource/getResources',
                    withCredentials:true,
                    type:'json',
                    params: {
                        modulePackage:this.select_module,
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.resourceData = response.data.data == null ? [] : response.data.data;
                        this.resourceDataAddId(this.resourceData);
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取resources失败");
                    console.log(error);       //请求失败返回的数据
                })
            },
            resourceDataAddId(data){
                for(let i=0;i<data.length;i++){
                    data[i].id = data[i].resource.id;
                    if(data[i].childList == null){
                        continue;
                    }
                    this.resourceDataAddId(data[i].childList);
                }
            },
            resetBtnVisible(){
                    this.delsBtnVisible = true;
                    this.delBtnVisible = true;
                    this.editBtnVisible = true;
                    this.createBtnVisible = true;
            },
            resetCardVisible(){
                this.createVisible = false;
                this.editVisible = false;
                this.delVisible = false;
                this.delsVisible = false;
            },
            resetVisible(){
                this.resetBtnVisible();
                this.resetCardVisible();
                this.createBtnVisible = false;
            },
            nodeClick(data,node,val){
                this.$refs.tree.setCheckedKeys([]);
                this.resetBtnVisible();
                this.resetCardVisible();
                this.editBtnVisible = false;
                this.delBtnVisible = false;
                this.createBtnVisible = false;
                this.current={
                    id:data.resource.id,
                    resourceName:data.resource.resourceName
                }
            },
            nodeChange(data,node,val){
                this.current = {};
                this.resetBtnVisible();
                this.resetCardVisible();
                this.delsBtnVisible = false;
                this.checkedResourceData = this.$refs.tree.getCheckedKeys();
                if(this.checkedResourceData.length==''){
                    this.resetBtnVisible();
                    this.createBtnVisible = false;
                    this.resetCurrent();
                }
            },
            handleCreate() {
                this.resetCardVisible();
                this.createVisible = true
                this.form = {}
                this.form.id = this.current.id;
            },
            handleEdit(index, row) {
                this.resetCardVisible();
                this.editVisible = true;
                this.form.id = this.current.id;
                this.getResource();
            },
            handleDel(index, row) {
                this.resetCardVisible();
                this.delVisible = true;
                this.form.id = this.current.id;
            },
            handleDels(index, row) {
                this.resetCardVisible();
                this.delsVisible = true;
            },
            deleteNodes(){
                this.$axios({
                    method:'get',
                    url: '/api/resource/resourceDeletes',
                    withCredentials:true,
                    params: {
                        resourceIds: this.checkedResourceData.join(",")
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.$message.success("删除成功");
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("删除resource失败");
                    console.log(error);       //请求失败返回的数据
                }).finally(()=>{
                    this.resetCurrent();
                    this.getData();
                    this.resetVisible();
                })
            },
            deleteNode(){
                this.$axios({
                    method:'get',
                    url: '/api/resource/resourceDelete',
                    withCredentials:true,
                    params: {
                        resourceId: this.form.id
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.$message.success("删除成功");
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("删除resource失败");
                    console.log(error);       //请求失败返回的数据
                }).finally(()=>{
                    this.resetCurrent();
                    this.getData();
                    this.resetVisible();
                })
            },
            saveEdit(){
                this.$axios({
                    method:'post',
                    url: '/api/resource/edit',
                    withCredentials:true,
                    data: this.$qs.stringify({
                        resourceId: this.form.id,
                        resourceName: this.form.resourceName,
                        resourcePath: this.form.resourcePath,
                        resourceIcon: 'el-icon-lx-'+this.form.resourceIcon,
                        detail: this.form.detail
                    })
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.$message.success("保存成功");
                        
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("保存resource失败");
                    console.log(error);       //请求失败返回的数据
                }).finally(()=>{
                    this.resetCurrent();
                    this.getData();
                    this.resetVisible();
                })
            },
            saveCreate(){
                this.$axios({
                    method:'post',
                    url: '/api/resource/create',
                    withCredentials:true,
                    data: this.$qs.stringify({
                        parentId: this.form.id,
                        resourceName: this.form.resourceName,
                        resourcePath: this.form.resourcePath,
                        resourceIcon: 'el-icon-lx-'+this.form.resourceIcon,
                        detail: this.form.detail
                    })
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.$message.success("保存成功");
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("保存resource失败");
                    console.log(error);       //请求失败返回的数据
                }).finally(()=>{
                    this.resetCurrent();
                    this.getData();
                    this.resetVisible();
                })
            },
            getResource(){
                this.$axios({
                    method:'get',
                    url: '/api/resource/getResource',
                    withCredentials:true,
                    params: {resourceId: this.current.id}
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        let iconStr = response.data.data.resourceIcon;
                        let _iconStr =iconStr.substring(11);
                        this.form={
                            id:this.current.id,
                            resourceName:response.data.data.resourceName,
                            resourcePath:response.data.data.resourcePath,
                            resourceIcon:_iconStr,
                            detail:response.data.data.detail
                        }
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取resource失败");
                    console.log(error);       //请求失败返回的数据
                })
            },
            //初始模块类型筛选select数据
            initModules(){
                this.$axios({
                    method:'get',
                    url:'/api/user/getModules',
                    withCredentials:true,
                    type:'json',
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.modules = response.data.data;
                        this.getData();
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error(`获取模块列表失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                })
            },
            moduleChage(){
                this.resetCurrent();
                this.resetVisible();
                this.getData();
            },
        }
    }

</script>

<style scoped>
    .handle-box {
        display: flex;
        justify-content:space-between;
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>
